import { Icon, IconProps } from "../Icon";

const Reset = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 28C24.6274 28 30 22.6274 30 16C30 9.37258 24.6274 4 18 4C11.3726 4 6 9.37258 6 16V22.2L2.4 18.6L1 20L7 26L13 20L11.6 18.6L8 22.2V16C8 10.4772 12.4772 6 18 6C23.5228 6 28 10.4772 28 16C28 21.5228 23.5228 26 18 26V28Z"
      fill="currentColor"
    />
  </Icon>
);

export default Reset;
